export { EloStripeIcon } from './stripe-icon'
